import Vue from 'vue'
import Router from 'vue-router'
import DeliveryMethods from '../mixins/delivery-methods'

// import { AmplifyEventBus } from "aws-amplify-vue"
import AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'

// Views
const Login = () => import('@/views/login/Login')
const Home = () => import('@/views/home/Home')
const FAQ = () => import('@/views/faq/FAQ')
const PreLoginFAQ = () => import('@/views/faq/PreLoginFAQ')
const Detail = () => import('@/views/detail/Detail')
const Contact = () => import('@/views/contact/Contact')
const Account = () => import('@/views/account/Account')
const News = () => import('@/views/news/News')
const Inspection = () => import('@/views/inspection/Inspection')
const ReRegistration = () => import('@/views/reregistration/ReRegistration')
const MailSending = () => import('@/views/reregistration/MailSending')
const Terms = () => import('@/views/terms/Terms')
const JLearningList = () => import('@/views/list/JLearningList')
const ServiceReportList = () => import('@/views/list/ServiceReportList')
const OrderForm = () => import('@/views/order/OrderForm')
const OrderHistory = () => import('@/views/order/OrderHistory')
const OrderConfirmation = () => import('@/views/order/OrderConfirmation')
const PracticeSupport = () => import('@/views/practiceSupport/PracticeSupport')
const PasswordSetting = () => import('@/views/login/PasswordSetting')
const LegalNotice = () => import('@/views/legalNotice/LegalNotice')
const ShoppingGuide = () => import('@/views/shoppingGuide/ShoppingGuide')

Vue.use(Router)
Vue.use(AmplifyPlugin, AmplifyModules)

const router = new Router({
  mode: 'history',
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

export default router

function configRoutes () {
  return [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/faq',
      name: 'FAQ',
      component: FAQ
    },
    {
      path: '/preloginfaq',
      name: 'PreLoginFAQ',
      component: PreLoginFAQ
    },
    {
      path: '/detail:id&:is_common',
      name: 'Detail',
      component: Detail
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/account',
      name: 'Account',
      component: Account
    },
    {
      path: '/news',
      name: 'News',
      component: News
    },
    {
      path: '/inspection',
      name: 'Inspection',
      component: Inspection
    },
    {
      path: '/reregistration',
      name: 'ReRegistration',
      component: ReRegistration
    },
    {
      path: '/mailsending',
      name: 'MailSending',
      component: MailSending
    },
    {
      path: '/terms',
      name: 'Terms',
      component: Terms
    },
    {
      path: '/jlearninglist',
      name: 'JLearningList',
      component: JLearningList
    },
    {
      path: '/servicereportlist',
      name: 'ServiceReportList',
      component: ServiceReportList
    },
    {
      path: '/orderform',
      name: 'OrderForm',
      component: OrderForm
    },
    {
      path: '/orderhistory',
      name: 'OrderHistory',
      component: OrderHistory
    },
    {
      path: '/orderconfirmation',
      name: 'OrderConfirmation',
      component: OrderConfirmation
    },
    {
      path: '/practiceSupport',
      name: 'PracticeSupport',
      component: PracticeSupport
    },
    {
      path: '/passwordSetting',
      name: 'PasswordSetting',
      component: PasswordSetting
    },
    {
      path: '/legalNotice',
      name: 'LegalNotice',
      component: LegalNotice
    },
    {
      path: '/shoppingGuide',
      name: 'ShoppingGuide',
      component: ShoppingGuide
    },
  ]
}

/**
 * セッション情報の確認を行う
 * 1. セッション情報無し -> ログイン画面
 * 2. 利用規約同意無し -> 利用規約画面
 * 3. 上記に当てはまらない場合 -> そのまま
 * @param {*} t0Path 遷移先のパス
 * * @param {*} fromPath 遷移元のパス
 */
function checkSessionInfo (toPath, fromPath) {
  // セッション確認
  switch (toPath) {
    case '/login':
    case '/reregistration':
    case '/mailsending':
    case '/faq':
    case '/preloginfaq':
    case '/terms':
    case '/passwordSetting':
    case '/legalNotice':
    case '/shoppingGuide':
      break
    default:
      // メールからの再登録画面へのリンクを開いたときの対応
      if (toPath.indexOf('/reregistration?token') !== -1) {
        break
      }
      console.log(sessionStorage)
      if (sessionStorage && Object.prototype.hasOwnProperty.call(sessionStorage, DeliveryMethods.USER_SESSION_SAVE_KEY)) {
        const account = JSON.parse(sessionStorage.getItem(DeliveryMethods.USER_SESSION_SAVE_KEY))
        switch (DeliveryMethods.DOMAIN) {
          case DeliveryMethods.DOMAIN_A_SITE:
            transitionToNextPage(toPath, fromPath, account.is_agreed_terms_a)            
            break
          case DeliveryMethods.DOMAIN_B_SITE:
            transitionToNextPage(toPath, fromPath, account.is_agreed_terms_b)
            break
          case DeliveryMethods.DOMAIN_C_SITE:
            transitionToNextPage(toPath, fromPath, account.is_agreed_terms_c)
            break
          default:
            throw new Error('Error Inappropriate value')
        }
      } else {
        router.replace({path: '/login'})
      }
      break
  }
}

/**
 * 次ページへの遷移を行う
 * @param {*} toPath 遷移先フルパス
 * @param {*} fromPath 遷移元フルパス
 * @param {*} accountType アカウントの種別
 */
function transitionToNextPage (toPath, fromPath, accountType) {  
  if (toPath.match(/orderform/) && fromPath.match(/orderform/)) {    
    router.go({path: toPath, force: true});
  } else {
    router.replace(accountType === 1 ? toPath : '/terms');
  }
}


router.beforeEach((to, from, next) => {
  console.log("beforeEach");
  // ログインと再登録画面への直接ページ遷移対策
  if (to.fullPath !== '/login' && to.fullPath !== '/reregistration') {
    next()
    return
  }
  if (sessionStorage && Object.prototype.hasOwnProperty.call(sessionStorage, DeliveryMethods.USER_SESSION_SAVE_KEY)) {
    const account = JSON.parse(sessionStorage.getItem(DeliveryMethods.USER_SESSION_SAVE_KEY))
    if (account) {
      router.replace('/home')
    }
  }
  next()
})

router.afterEach((to, from) => {  
  // セッションに現画面のパスを保存
  console.log('afterEach ')
  sessionStorage.setItem('route_path', to.fullPath)
  checkSessionInfo(to.fullPath, from.fullPath)  
})

// ユーザー管理
getUser().then((user) => {
  if (user) {
    console.log('UserSession: ', 'session find')
  } else {
    console.log('UserSession: ', 'no session')
  }
})

function getUser () {
  return Vue.prototype.$Amplify.Auth.currentAuthenticatedUser()
    .then((data) => {
      if (data && data.signInUserSession) {
        return data
      }
    })
    .catch(() => {
      console.log('getUser: ', 'no current Session')
      return null
    })
}



// WEBPACK FOOTER //
// ./src/router/index.js